export default __webpack_public_path__ + "static/media/warning--offset-roads--g1.b417a496.png";